import React, { useState, useEffect } from "react";
import {
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import {
  Card,
  CardContent,
} from "../../components/ui/card";

import { motion, AnimatePresence } from "framer-motion";
import AddProject from "../../components/admin/AddProject";
import AddBlog from "../../components/admin/AddBlog";
import EditProject from "../../components/admin/EditProject";
import EditBlog from "../../components/admin/EditBlog";
import UserManagement from "../../components/admin/UserManagement";
import AdminTopBar from "../../components/admin/AdminTopBar";
import AdminSidebar from "../../components/admin/AdminSidebar";
import BlogsManagement from "@/components/admin/BlogsManagement";
import ProjectsManagement from "@/components/admin/ProjectsManagement";
import SubscribersManagement from "@/components/admin/SubscribersManagement";
import DashboardOverview from "@/components/admin/DashboardOverview";
import ProfilePage from "@/components/admin/ProfilePage";
import SettingPage from "@/components/admin/SettingPage";
import TestimonialManagement from "@/components/admin/TestimonialManagement";
import EditTestimonial from "@/components/admin/EditTestimonial";
import AddTestimonial from "@/components/admin/AddTestimonial";
import CertificationsManagement from "@/components/admin/CertificationsManagement";
import AddCertification from "@/components/admin/AddCertification";
import EditCertification from "@/components/admin/EditCertification";

const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem("adminToken");

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // min-h-screen bg-muted/30 dark:bg-background flex flex-col lg:flex-col
  return (
    <div className="flex min-h-screen bg-muted/30 dark:bg-background">
      {/* Mobile sidebar backdrop */}
      <AnimatePresence>
        {sidebarOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-40 bg-black lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}
      </AnimatePresence>

      {/* Sidebar */}
      <AdminSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Main content area */}
      <div className="flex-1 flex flex-col lg:pl-64">
        <AdminTopBar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
        <main className="p-6 flex-1 overflow-y-auto">
          <Routes>
            <Route index element={<DashboardOverview />} />
            <Route path="dashboard" element={<DashboardOverview />} />
            <Route path="projects" element={<ProjectsManagement />} />
            <Route path="projects/add" element={<AddProject />} />
            <Route path="projects/edit/:id" element={<EditProject />} />
            <Route path="blogs" element={<BlogsManagement />} />
            <Route path="blogs/add" element={<AddBlog />} />
            <Route path="blogs/edit/:id" element={<EditBlog />} />
            <Route path="certifications" element={<CertificationsManagement />} />
            <Route path="certifications/add" element={<AddCertification />} />
            <Route path="certifications/edit/:id" element={<EditCertification />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="subscribers" element={<SubscribersManagement />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="testimonials" element={<TestimonialManagement />} />
            <Route path="testimonials/edit/:id" element={<EditTestimonial />} />
            <Route path="testimonials/add" element={<AddTestimonial />} />
            <Route
              path="settings"
              element={
                <SettingPage />
              }
            />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
